// Keep only the user's edits when loading a newer server revision.
export function mergeProfileDraft(baseline, draft, fresh) {
  const merged = { ...fresh };
  for (const key of Object.keys(draft)) {
    if (JSON.stringify(draft[key]) !== JSON.stringify(baseline[key])) merged[key] = draft[key];
  }
  return merged;
}
export function profileError(error, fallback = 'Profil kaydedilemedi.') {
  const detail = error.response?.data?.detail;
  return typeof detail === 'string' ? detail : detail?.message || fallback;
}
